import connectGetter from 'lib/common/utils/connectGetter';
import getContactConnection from 'lib/common/utils/getContactConnection';

const CUSTOMER_CONNECTION_VALUE = 'Customer';

export function getConnectionValueFromContact(contact: connect.Contact) {
  return (
    connectGetter(getContactConnection(contact), 'getEndpoint')?.phoneNumber ||
    connectGetter(contact, 'getName') ||
    CUSTOMER_CONNECTION_VALUE
  );
}
